import {Component, Inject, Input, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {User} from '../../../_models';
import {OrgTable} from '../../../_models/orgTable';
import {UtilsService} from '../../../_services/utils.service';

@Component({
  selector: 'app-notification-popup',
  templateUrl: './qr-pay-popup.component.html',
  styleUrls: ['./qr-pay-popup.component.scss']
})
export class QrPayPopupComponent implements OnInit {

  description: string;
  message: string;
  currentUser: User;
  qrUrl = '';
  title = '';
  imageSrc = '';
  height = 300;
  width = 300;
  colorLight  = '#ffffffff';
  colorDark = '#000000ff';
  tableSelectorEnabled = false;
  orderFinished = false;
  private tables: OrgTable[] = [];
  private selectedTable: string;
  downloadButtonEnabled = false;


  constructor(private dialogRef: MatDialogRef<QrPayPopupComponent>, private utilsService: UtilsService,
              @Inject(MAT_DIALOG_DATA) data) {
    this.description = data.title;
    this.message = data.message;
    this.qrUrl = data.qrUrl;
    this.imageSrc = data.imageSrc;
    this.downloadButtonEnabled = data.downloadButtonEnabled;
    this.currentUser = utilsService.getCurrentUser();
    this.tableSelectorEnabled = data.tableSelector;
  }

  ngOnInit() {
    this.tables = this.currentUser.orgSettings.tables;
  }

  close() {
    this.orderFinished = true;
    this.dialogRef.close({});
  }

  addTableToAutologin(item: any) {
    if (this.qrUrl.includes('&table=')) {
      this.qrUrl = this.qrUrl.substring(0, this.qrUrl.indexOf('&table='));
    }
    this.qrUrl = this.qrUrl + '&table=' + item.replace(/\s/g, '');
    this.selectedTable = item.replace(/\s/g, '');
    this.title = 'Table ' +this.selectedTable;
  }

  saveAsImage(parent) {
    let parentElement = null;

    // fetches base 64 data from canvas
    parentElement = parent.qrcElement.nativeElement
        .querySelector('canvas')
        .toDataURL('image/png');

    if (parentElement) {
      // converts base 64 encoded image to blobData
      const blobData = this.convertBase64ToBlob(parentElement);
      // saves as image
      const blob = new Blob([blobData], { type: 'image/png' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      // name of the file
      link.download = 'DineNGo QR Code ' + this.selectedTable;
      link.click();
    }
  }

  private convertBase64ToBlob(Base64Image: string) {
    // split into two parts
    const parts = Base64Image.split(';base64,');
    // hold the content type
    const imageType = parts[0].split(':')[1];
    // decode base64 string
    const decodedData = window.atob(parts[1]);
    // create unit8array of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length);
    // insert all character code into uint8array
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // return blob image after conversion
    return new Blob([uInt8Array], { type: imageType });
  }
}

